import { Component, OnInit } from '@angular/core';
import {EventsManager} from "../../events/events.manager";
import {PlansService} from "../../services/plans.service";
import {GetDocumentDetailRequest} from "../../models/document.request";
import { PhonePipe } from '../../pipes/phone.pipe';
import {ActivatedRoute, RouterLink} from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule, NgFor, RouterLink, PhonePipe]
})
export class SupportComponent implements OnInit {
  plans:any = {};
  currentYear:number = 2025;
  prevFeeUrl:string = '';
  prevDiscountUrl:string = '';
  currFeeUrl:string = '';
  currDiscountUrl:string = '';
  stateChosen:boolean = false;
  currentState:any = {};
  selectedState:string = '';
  stateAbbr:string = '';
  info:any = {};
  showIfPurchaseIsNotAdha:boolean = false;
  previousPrefixText:string = '';
  currentPrefixText:string = '';
  constructor( private plansSrvc: PlansService, public em:EventsManager,private route:ActivatedRoute) { }

  ngOnInit(): void {
   this.plans = this.em.getOfficeInfo();

   this.info = this.em.contactInfo;
    this.em.contactInfoUpdated.subscribe(
      (info:any) => {
        this.info = this.em.contactInfo;
      }
    )
    if(this.em.purchaseIsADHA){
      this.stateAbbr = 'ADHA';
    }
    const url: string = this.route.snapshot.url.join('|');
    if(url.includes('adha')) {
      this.stateAbbr = 'ADHA';
      this.stateChosen = true;
      this.em.purchaseIsADHA = true;
      this.showIfPurchaseIsNotAdha = true;
      this.em.setHideHeader(true);
      this.getPlanDocuments();
    }

    this.previousPrefixText = (this.currentYear-1).toString();
    this.currentPrefixText = this.currentYear.toString();
    if(this.showIfPurchaseIsNotAdha){
      this.currentPrefixText = 'ADHA';
    }

    if(sessionStorage['state'] && !this.showIfPurchaseIsNotAdha){
      this.currentState = JSON.parse(sessionStorage['state']);
      this.selectedState = this.currentState.name;
      this.stateAbbr = this.currentState.abbr;
      this.stateChosen = true;
      this.getPlanDocuments();
    }
  }

  stateChanged(state:any) {
    if(state.target.value !== 'none'){
      this.stateAbbr = state.target.value;
      this.stateChosen = true;
      state.target.blur();
      this.getPlanDocuments();
    } else {
      this.stateChosen = false;
    }
  }

  openUrl(url:string){
    console.log('url: ', url);
    switch(url){
      case "prevFees":
        console.log('url: ', this.prevFeeUrl);
        window.open(this.prevFeeUrl);
        break;
      case "prevDiscount":
        console.log('url: ', this.prevDiscountUrl);
        window.open(this.prevDiscountUrl);
        break;
      case "currFees":
        console.log('url: ', this.currFeeUrl);
        window.open(this.currFeeUrl);
        break;
      case "currDiscount":
        console.log('url: ', this.currDiscountUrl);
        window.open(this.currDiscountUrl);
        break;
    }

  }

  getPlanDocuments(){
    if(!this.showIfPurchaseIsNotAdha){
      const docReq:GetDocumentDetailRequest = {category:'PlanDetails,MembershipAgreements',brand:'sgdp',year:(this.currentYear-1).toString(),organizationId:this.em.orgId,coverageLevelName:'',planName:'',state:this.stateAbbr};
      this.plansSrvc.getDocumentDetails(docReq).subscribe(
        (response) => {
          const urls = response.split(",");
          this.prevFeeUrl = urls[1];
          this.prevDiscountUrl = urls[0];
        }
      );
      const docReq2:GetDocumentDetailRequest = {category:'PlanDetails,MembershipAgreements',brand:'sgdp',year:(this.currentYear).toString(),organizationId:this.em.orgId,coverageLevelName:'',planName:'',state:this.stateAbbr};
      this.plansSrvc.getDocumentDetails(docReq2).subscribe(
        (response) => {
          const urls = response.split(",");
          this.currFeeUrl = urls[1];
          this.currDiscountUrl = urls[0];
        }
      )
    } else {

      console.log(this.currentPrefixText);
      const docReq:GetDocumentDetailRequest = {category:'PlanDetails,MembershipAgreements',brand:'sgdp',year:(this.currentYear).toString(),organizationId:this.em.orgId,coverageLevelName:'',planName:'',state:'ADHA'};
      this.plansSrvc.getDocumentDetails(docReq).subscribe(
        (response) => {
          const urls = response.split(",");
          this.currFeeUrl = urls[1];
          this.currDiscountUrl = urls[0];
        }
      );
    }

  }
}
